"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalWrapper = void 0;

var _stylitas = require("@creditas/stylitas");

var _styledTools = require("styled-tools");

const ModalWrapper = _stylitas.styled.div`
  position: relative;
  z-index: ${(0, _styledTools.prop)('zIndex', 1000)};
`;
exports.ModalWrapper = ModalWrapper;